<template>
  <div
    class="container"
    :style="{ backgroundImage: 'url(' + currentBackground + ')' }"
  >
    <div class="text-container">
      <div class="text">{{ $t('home.title') }}</div>
      <el-button @click="handleMore" round plain>{{ $t('home.button') }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyIntroduce",
  data() {
    return {
      currentIndex: 0,
      intervalId: null,
      backgrounds: [
        new URL("../../assets/images/home.jpg", import.meta.url),
        // new URL("../../assets/images/home-2.png", import.meta.url),
      ],
    };
  },
  computed: {
    currentBackground() {
      return this.backgrounds[this.currentIndex];
    },
  },
  methods: {
    handleMore() {
      this.$router.push(`/companyIntroduce`);
      this.$emit("changeActive");
    },
    nextBackground() {
      this.currentIndex = (this.currentIndex + 1) % this.backgrounds.length;
    },
  },
  mounted() {
    this.intervalId = setInterval(this.nextBackground, 15000); // 每15秒更换一次背景
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 864px;
  text-align: center;
  position: relative;
  background-size: cover; /* 背景图片覆盖整个div区域 */
  transition: background-image 1s; /* 背景图片切换有过渡效果 */
  /* background: url("@/assets/images/home.jpg") no-repeat; */
  /* background-size: 100%; */
}
.banner {
  width: 100%;
  height: 864px;
}
.text {
  font-size: 65px;
  font-weight: 700;
  padding-bottom: 20px;
  color: #ffffff;
}
.text-container {
  position: absolute;
  left: 50%;
  width: 100%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.el-button {
  background: unset;
  color: #ffffff;
  border: 2px solid #ffffff;
  font-weight: 600;
  font-size: 24px;
  border-radius: 36px !important;
}
.el-button--small,
.el-button--small.is-round {
  padding: 18px 26px;
}
:deep(.el-button:hover) {
  background-color: transparent;
  color: white;
  border-color: white;
}
</style>
